(function () {
  function initCarousel(root) {
    // Evita inicializar o mesmo carrossel mais de uma vez
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var track = root.querySelector('[data-testimonials-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-testimonials-slide]'));
    var section = root.closest('.testimonials');
    var dotsWrap = section.querySelector('[data-testimonials-dots]');

    if (!track || slides.length === 0) return;

    if (dotsWrap) {
      dotsWrap.innerHTML = ''; // limpa qualquer dot criado anteriormente

      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials__dot';
        dot.setAttribute('aria-label', 'Ir para depoimento ' + (i + 1));
        dot.addEventListener('click', function () {
          slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

    function updateActiveState() {
      var trackRect = track.getBoundingClientRect();
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var distance = Math.abs(rect.left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    function scrollByCard(direction) {
      var card = slides[0];
      var cardWidth = card.getBoundingClientRect().width;
      var gap = 20;
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByCard(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByCard(-1); }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateActiveState();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    if (root.dataset.autoplay === 'true') {
      var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
      var autoplayTimer = setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByCard(1);
        }
      }, speed);

      ['pointerdown', 'keydown'].forEach(function (evt) {
        root.addEventListener(evt, function () { clearInterval(autoplayTimer); }, { once: true });
      });
    }

    updateActiveState();
    window.addEventListener('resize', updateActiveState);
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // No editor de temas, quando a section é re-renderizada (ex: editando um setting),
  // o Shopify recria o HTML do zero — então reseta o "initialized" pra permitir reinicializar
  document.addEventListener('shopify:section:load', function (e) {
    var carousel = e.target.querySelector('[data-testimonials-carousel]');
    if (carousel) {
      carousel.dataset.initialized = 'false';
      initCarousel(carousel);
    }
  });
})();